<template>
    <Pembayaran jenisPembayaran="PP" />
</template>

<script>

import Pembayaran from '../../components/pembayaran/Pembayaran'

export default {
    name: 'perpanjangan-pembayaran',
    components: {
        Pembayaran,
    }
}
</script>